module.exports = __webpack_public_path__ + "media/images/site/background-f7a2cbc154431dfcbcbdf3b6bdce1817.png";